import React from "react";
import { Microscope24Filled } from "@fluentui/react-icons";

export const ANALYSIS_ORDER_STEP_LABELS = ["Order information", "Select analyses", "Preparation and routing", "Review and submit"];

interface AnalysisOrderStepsProps {
    currentStep: number;
    onStepClick?: (stepIndex: number) => void;
}

export function AnalysisOrderSteps({ currentStep, onStepClick }: AnalysisOrderStepsProps) {
    return (
        <div className="flex flex-wrap items-center gap-2 text-sm text-primary-dark dark:text-primary-light">
            <Microscope24Filled />
            {ANALYSIS_ORDER_STEP_LABELS.map((label, index) => {
                const isCompleted = index < currentStep;
                const isCurrent = index === currentStep;
                const textClassName = isCurrent
                    ? "font-bold text-primary-dark dark:text-white"
                    : isCompleted
                        ? "text-primary-dark dark:text-primary-light"
                        : "text-primary-dark/75 dark:text-primary-light/75";
                const stepClassName = isCurrent
                    ? "border-2 border-oi-button-blue bg-oi-button-blue text-white"
                    : "border-2 border-oi-button-blue bg-transparent text-primary-dark dark:text-primary-light";

                const content = (
                    <>
                        <span className={`flex h-7 w-7 items-center justify-center rounded-full border text-xs font-semibold ${stepClassName}`}>
                            {isCompleted ? "✓" : index + 1}
                        </span>
                        <span>{label}</span>
                    </>
                );

                return (
                    <React.Fragment key={label}>
                        {onStepClick ? (
                            <button type="button" className={`flex items-center gap-2 ${textClassName}`} onClick={() => onStepClick(index)}>
                                {content}
                            </button>
                        ) : (
                            <div className={`flex items-center gap-2 ${textClassName}`}>
                                {content}
                            </div>
                        )}
                        {index < ANALYSIS_ORDER_STEP_LABELS.length - 1 && <span className="text-primary-dark dark:text-primary-light">→</span>}
                    </React.Fragment>
                );
            })}
        </div>
    );
}